'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.employeeSyncService', [])

.factory('employeeSyncService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/API/PublisherEmployee';

    // Get Matching Rules
    service.getMatchingRules = function () {
        return $http.get(baseUrl + '/Matching/MatchingRule')
        .then(function (response) {
            return response.data;
        });
    };

    // Get Latest Batch
    service.getLatestBatch = function () {
        return $http.get(baseUrl + '/Batch/Latest')
        .then(function (response) {
            return response.data;
        });
    };

    // Get Latest Closed Batch
    service.getLatestClosedBatch = function () {
        return $http.get(baseUrl + '/Batch/Closed/Latest')
        .then(function (response) {
            return response.data;
        });
    };

    // Get Exceptions By Batch ID
    service.getExceptionsByBatchId = function (batchId) {
        return $http.get(baseUrl + '/Batch/'  + batchId + '/Exception')
        .then(function (response) {
            return response.data;
        });
    };

    // Get Not Confirmed And Last Matching Staging Records
    service.getNotConfirmedAndLastMatchingStagingRecords = function () {
        return $http.get(baseUrl + '/Matching/NotConfirmed/Last')
        .then(function (response) {
            return response.data;
        });
    };

    // Get Business Units By Matching
    service.getBusinessUnitsByMatching = function (matchingStagingRecord) {

        var reqUrl = baseUrl + '/Matching/' +
                     matchingStagingRecord.PubEmp_MatchingStagingID +
                     '/BusinessUnit'

        return $http.get(reqUrl)
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Get Infos On Employee Properties
    service.getInfosOnEmployeeProperties = function (matchingStagingRecord) {
        return $http.get(baseUrl + '/Matching/' +
                         matchingStagingRecord.PubEmp_MatchingStagingID +
                         '/Infos/EmployeeProperties/Staging/' + matchingStagingRecord.PubEmp_StagingID)
        .then(function (response) {
            return response.data;
        });
    };

    // Get Infos On Employee Update Properties
    service.getInfosOnEmployeeUpdateProperties = function (matchingStagingRecord) {
        return $http.get(baseUrl + '/Matching/' +
                         matchingStagingRecord.PubEmp_MatchingStagingID +
                         '/Infos/EmployeeUpdateProperties/Staging/' + matchingStagingRecord.PubEmp_StagingID)
        .then(function (response) {
            return response.data;
        });
    };

    // Get Infos On Employee Update Pending Properties
    service.getInfosOnEmployeeUpdatePendingProperties = function (matchingStagingRecord) {
        return $http.get(baseUrl + '/Matching/' +
                         matchingStagingRecord.PubEmp_MatchingStagingID +
                         '/Infos/EmployeeUpdatePendingProperties/Staging/' + matchingStagingRecord.PubEmp_StagingID)
        .then(function (response) {
            return response.data;
        });
    };

    // Get Infos On Employee New Supervisor
    service.getInfosOnEmployeeNewSupervisor = function (matchingStagingRecord) {
        return $http.get(baseUrl + '/Matching/' +
                         matchingStagingRecord.PubEmp_MatchingStagingID +
                         '/Infos/EmployeeNewSupervisor/Staging/' + matchingStagingRecord.PubEmp_StagingID)
        .then(function (response) {
            return response.data;
        });
    };

    // Get Infos On Employee Contract Renewal
    service.getInfosOnEmployeeContractRenewal = function (matchingStagingRecord) {
        return $http.get(baseUrl + '/Matching/' +
                         matchingStagingRecord.PubEmp_MatchingStagingID +
                         '/Infos/EmployeeContractRenewal/Staging/' + matchingStagingRecord.PubEmp_StagingID)
        .then(function (response) {
            return response.data;
        });
    };

    // Get Stagings by Matching
    service.getStagingsByMatching = function (matchingStagingId) {
        return $http.get(baseUrl + '/Matching/' + matchingStagingId + '/Staging')
        .then(function (response) {
            return response.data;
        });
    };

    // Confirm Matching
    service.confirmMatching = function (matchingStagingRecord) {
        return $http.post(baseUrl + '/Matching/' +
                         matchingStagingRecord. PubEmp_MatchingStagingID +
                         '/Confirm/' + matchingStagingRecord.PubEmp_MatchingRuleName)
        .then(function (response) {
            return response.data;
        });
    };

    // Confirm Matching By Rule
    service.confirmMatchingByRule = function (matchingStagingRuleName) {
        return $http.post(baseUrl + '/Matching/Confirm/' + matchingStagingRuleName)
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Confirm Matching with Effective Date
    service.confirmMatchingWithEffectiveDate = function (matchingStagingRecord, effectiveDate) {
        return $http.post(baseUrl + '/Matching/' +
                         matchingStagingRecord.PubEmp_MatchingStagingID +
                         '/Confirm/' + matchingStagingRecord.PubEmp_MatchingRuleName +
                         '/EffectiveDate/' + effectiveDate,
                         matchingStagingRecord)
        .then(function (response) {
            return response.data;
        });
    };

    // Confirm Matching with Employee Login
    service.confirmMatchingWithUsername = function (matchingStagingRecord, username) {
        return $http.post(baseUrl + '/Matching/' +
                         matchingStagingRecord.PubEmp_MatchingStagingID +
                         '/Confirm/' + matchingStagingRecord.PubEmp_MatchingRuleName +
                         '/Username/' + username,
                         matchingStagingRecord)
        .then(function (response) {
            return response.data;
        });
    };

    // Ignore Matching
    service.ignoreMatching = function (matchingStagingRecord) {
        return $http.post(baseUrl + '/Matching/' +
                         matchingStagingRecord. PubEmp_MatchingStagingID +
                         '/Ignore/' + matchingStagingRecord.PubEmp_MatchingRuleName)
        .then(function (response) {
            return response.data;
        });
    };

    // Get Ignored Matchings When Confirm Matching
    service.getIgnoredMatchingsWhenConfirmMatching = function (matchingStagingRecord) {
        return $http.get(baseUrl + '/Matching/' +
                         matchingStagingRecord. PubEmp_MatchingStagingID +
                         '/PreConfirm/' + matchingStagingRecord.PubEmp_MatchingRuleName)
        .then(function (response) {
            return response.data;
        });
    };

    return service;
}]);
